import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, createTextVNode as _createTextVNode, vModelText as _vModelText, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "card mb-2 d-print-none" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-2 col-6" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "col-md-2 col-6" }
const _hoisted_7 = { class: "col-md-2 col-6" }
const _hoisted_8 = { class: "col-md-2 col-6" }
const _hoisted_9 = { class: "col-md-2 col-6" }
const _hoisted_10 = { class: "col-md-2 col-6" }
const _hoisted_11 = ["title"]
const _hoisted_12 = { class: "col-md-2 col-6" }
const _hoisted_13 = ["title"]
const _hoisted_14 = { class: "col-md-2 col-6" }
const _hoisted_15 = { class: "dropdown" }
const _hoisted_16 = {
  class: "dropdown-menu p-2",
  style: {"min-width":"200px"}
}
const _hoisted_17 = { class: "form-check" }
const _hoisted_18 = ["id", "onUpdate:modelValue"]
const _hoisted_19 = ["for"]
const _hoisted_20 = { class: "col-md-2 col-6" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = {
  key: 0,
  class: "col-md-12 text-center"
}
const _hoisted_23 = { class: "p-4 text-danger fw-14" }
const _hoisted_24 = {
  key: 1,
  class: "col-md-12 text-center"
}
const _hoisted_25 = {
  key: 3,
  class: "text-center p-4 text-muted"
}
const _hoisted_26 = {
  key: 4,
  class: "text-center p-4 text-muted"
}

import { reactive, computed } from "vue";
import * as XLSX from "xlsx";

import * as relatoriosService from "@/services/relatoriosService";
import { fdata, SimNao } from "@/utils/funcoes";
import { useOrdenacao } from "@/composables/useOrdenacao";

import BreadCrumb from "@/components/Common/BreadCrumb.vue";
import Notificacao from "@/components/Notificacao/Index.vue";
import TrataTecla from "@/components/TrataTecla/Index.vue";
import DropdownCidadesAtiva from "@/components/Dropdowns/DropdownCidadesAtiva.vue";
import DropdownEmpresas from "@/components/Dropdowns/DropdownEmpresas.vue";

import ReportView from "@/components/ReportView/Index.vue";
import ReportCabecalho from "@/components/ReportView/Cabecalho.vue";

import RelNormal from "@/pages/Relatorios/Clientes/relNormal.vue";
import RelFuneral from "@/pages/Relatorios/Clientes/relFuneral.vue";
import RelSeguro from "@/pages/Relatorios/Clientes/relSeguro.vue";

interface LinhaPessoa {
  nome: string;
  dataNascimento: string | null;
  cpf: string | null;
  tipo: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {


const apresentacoes = ["Normal", "Assistência Funeral", "Seguro"];

const colunasOpcionais = [
  { chave: "cpf", label: "CPF" },
  { chave: "nascimento", label: "Nasc." },
  { chave: "idade", label: "Idade" },
  { chave: "telefone", label: "Telefone" },
  { chave: "cidade", label: "Cidade" },
  { chave: "ativo", label: "Ativo" },
];

const controle = reactive({
  filtros: {
    ativo: true,
    cidadeId: null,
    empresaId: null,
    comDependentes: true,
    dataNascimentoInicial: null,
    dataNascimentoFinal: null,
  } as relatoriosService.FiltroRelatorioClientes,

  apresentacao: "Normal",

  usarIdadeInicial: true,
  usarIdadeFinal: true,
  idadeInicial: null as number | null,
  idadeFinal: null as number | null,

  colunasVisiveis: {
    cpf: true,
    nascimento: true,
    idade: true,
    telefone: true,
    cidade: true,
    ativo: true,
  } as Record<string, boolean>,

  cidadeNome: "" as string,
  empresaNome: "" as string,

  itens: [] as relatoriosService.RelClienteDTO[],
  totalRegistros: 0,

  erro: "",
  status: "",
  pesquisando: false,
});

function calcIdade(dataNascimento: string | null): number | null {
  if (!dataNascimento) return null;
  const nascimento = new Date(dataNascimento);
  const hoje = new Date();
  let idade = hoje.getFullYear() - nascimento.getFullYear();
  const aindaNaoFezAniversario =
    hoje.getMonth() < nascimento.getMonth() ||
    (hoje.getMonth() === nascimento.getMonth() && hoje.getDate() < nascimento.getDate());
  if (aindaNaoFezAniversario) idade--;
  return idade;
}

function idadeParaData(idade: number | null): string | null {
  if (idade === null || idade === undefined || isNaN(idade)) return null;
  const hoje = new Date();
  const data = new Date(hoje.getFullYear() - idade, hoje.getMonth(), hoje.getDate());
  return data.toISOString().substring(0, 10);
}

function dataParaIdade(data: string | null): number | null {
  if (!data) return null;
  return calcIdade(data);
}

// Idade e data de nascimento andam em ordem invertida: quem é mais velho tem data de nascimento MENOR.
// "Idade Inicial" (idade mínima) equivale ao limite MAIS RECENTE de nascimento (Dt Nasc Final).
// "Idade Final" (idade máxima) equivale ao limite MAIS ANTIGO de nascimento (Dt Nasc Inicial).
function alternarIdadeInicial() {
  controle.usarIdadeInicial = !controle.usarIdadeInicial;
  if (controle.usarIdadeInicial) {
    controle.idadeInicial = dataParaIdade(controle.filtros.dataNascimentoFinal);
  } else {
    controle.filtros.dataNascimentoFinal = idadeParaData(controle.idadeInicial);
  }
}

function alternarIdadeFinal() {
  controle.usarIdadeFinal = !controle.usarIdadeFinal;
  if (controle.usarIdadeFinal) {
    controle.idadeFinal = dataParaIdade(controle.filtros.dataNascimentoInicial);
  } else {
    controle.filtros.dataNascimentoInicial = idadeParaData(controle.idadeFinal);
  }
}

function atualizarDataPelaIdadeInicial() {
  controle.filtros.dataNascimentoFinal = idadeParaData(controle.idadeInicial);
}

function atualizarDataPelaIdadeFinal() {
  controle.filtros.dataNascimentoInicial = idadeParaData(controle.idadeFinal);
}

function selecionouCidade(cidade: any) {
  controle.cidadeNome = cidade ? `${cidade.nome} - ${cidade.estado}` : "";
}

function selecionouEmpresa(empresa: any) {
  controle.empresaNome = empresa ? empresa.nome : "";
}

const resumoFiltros = computed(() => {
  const partes = [
    `Apresentação: ${controle.apresentacao}`,
    `Status: ${controle.filtros.ativo === true ? "Ativos" : controle.filtros.ativo === false ? "Inativos" : "Todos"}`,
    `Cidade: ${controle.filtros.cidadeId ? controle.cidadeNome : "Todas"}`,
    `Empresa: ${controle.filtros.empresaId ? controle.empresaNome : "Todas"}`,
    `Com Dependentes: ${controle.filtros.comDependentes === true ? "Sim" : controle.filtros.comDependentes === false ? "Não" : "Todos"}`,
    `Dt Nascimento: ${controle.filtros.dataNascimentoInicial ? fdata(controle.filtros.dataNascimentoInicial) : "..."} a ${controle.filtros.dataNascimentoFinal ? fdata(controle.filtros.dataNascimentoFinal) : "..."}`,
  ];
  return partes.join("  |  ");
});

function dataDentroDoFiltro(data: string | null): boolean {
  if (!controle.filtros.dataNascimentoInicial && !controle.filtros.dataNascimentoFinal) return true;
  if (!data) return false;

  const d = data.substring(0, 10);

  if (controle.filtros.dataNascimentoInicial && d < controle.filtros.dataNascimentoInicial) return false;
  if (controle.filtros.dataNascimentoFinal && d > controle.filtros.dataNascimentoFinal) return false;

  return true;
}

const sortNormal = useOrdenacao("nome");
const sortPessoas = useOrdenacao("nome");

const itensOrdenados = computed(() => sortNormal.aplicar(controle.itens, {
  idade: (item: relatoriosService.RelClienteDTO) => calcIdade(item.dataNascimento) ?? -1,
  nascimento: (item: relatoriosService.RelClienteDTO) => item.dataNascimento || "",
  telefone: (item: relatoriosService.RelClienteDTO) => item.celular || item.telefone || "",
  cidade: (item: relatoriosService.RelClienteDTO) => item.cidadeNome || "",
}));

const linhasPessoas = computed<LinhaPessoa[]>(() => {
  const linhas: LinhaPessoa[] = [];

  // Nos modos Assistência Funeral / Seguro o filtro de data é aplicado por pessoa (titular e cada dependente),
  // não só pelo titular como no modo Normal.
  const aplicarFiltroData = controle.apresentacao !== "Normal";

  controle.itens.forEach((cliente) => {
    if (!aplicarFiltroData || dataDentroDoFiltro(cliente.dataNascimento)) {
      linhas.push({ nome: cliente.nome, dataNascimento: cliente.dataNascimento, cpf: cliente.cpf, tipo: "Titular" });
    }

    if (controle.apresentacao === "Assistência Funeral") {
      cliente.dependentes
        .filter((dep) => !aplicarFiltroData || dataDentroDoFiltro(dep.dataNascimento))
        .forEach((dep) => {
          linhas.push({ nome: dep.nome, dataNascimento: dep.dataNascimento, cpf: dep.cpf, tipo: dep.parentesco || "Dependente" });
        });
    } else if (controle.apresentacao === "Seguro") {
      cliente.dependentes
        .filter((dep) => (dep.parentesco || "").toLowerCase().includes("conjuge") || (dep.parentesco || "").toLowerCase().includes("cônjuge"))
        .filter((dep) => !aplicarFiltroData || dataDentroDoFiltro(dep.dataNascimento))
        .forEach((dep) => {
          linhas.push({ nome: dep.nome, dataNascimento: dep.dataNascimento, cpf: dep.cpf, tipo: dep.parentesco || "Cônjuge" });
        });
    }
  });

  return linhas;
});

const linhasPessoasOrdenadas = computed(() => sortPessoas.aplicar(linhasPessoas.value, {
  dataNascimento: (item: LinhaPessoa) => item.dataNascimento || "",
}));

async function pesquisar() {
  controle.pesquisando = true;
  controle.erro = "";
  try {
    // Nos modos Assistência Funeral / Seguro o filtro de data não é enviado ao backend (que filtraria só pelo
    // titular); a filtragem por pessoa é feita depois, em linhasPessoas.
    const filtrosEnvio = { ...controle.filtros };
    if (controle.apresentacao !== "Normal") {
      filtrosEnvio.dataNascimentoInicial = null;
      filtrosEnvio.dataNascimentoFinal = null;
    }

    const r = await relatoriosService.clientes(filtrosEnvio);
    controle.totalRegistros = r.totalRegistros;
    controle.itens = r.dados;
  } catch (e: any) {
    controle.erro = e?.message || "Erro ao pesquisar clientes";
  } finally {
    controle.pesquisando = false;
  }
}

function gerarExcel() {
  const pagina = document.getElementById("pagina");
  if (!pagina) return;

  const tabelas = pagina.querySelectorAll("table");
  if (tabelas.length === 0) return;

  // Mesmas colunas exibidas na tela (e no CSV): lê direto do DOM da tabela renderizada,
  // então funciona igual nos 3 modos de apresentação (Normal/Assistência Funeral/Seguro).
  // Todo valor é mantido como texto (string) — inclusive o CPF — pra não deixar o Excel
  // reinterpretar como número/data e perder zero à esquerda.
  const linhas: string[][] = [];
  tabelas.forEach((t) => {
    t.querySelectorAll("tr").forEach((tr) => {
      const celulas = [...tr.querySelectorAll("th,td")].map((c) => (c.textContent || "").trim());
      linhas.push(celulas);
    });
  });

  const planilha = XLSX.utils.aoa_to_sheet(linhas);
  const livro = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(livro, planilha, "Clientes");
  XLSX.writeFile(livro, "Rel Clientes.xlsx");
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, {
      PageTitle: "Relatório de Clientes",
      items: [
    { label: 'Relatórios', to: '/relatorios' },
    { label: 'Clientes', to: '/relatorios/clientes' }]
    }),
    _createVNode(Notificacao, {
      erro: controle.erro,
      onLimparErro: _cache[0] || (_cache[0] = ($event: any) => (controle.erro = '')),
      progresso: controle.status,
      onLimparProgresso: _cache[1] || (_cache[1] = ($event: any) => (controle.status = ''))
    }, null, 8, ["erro", "progresso"]),
    _createVNode(TrataTecla, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Apresentação", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((controle.apresentacao) = $event)),
                  class: "form-select form-select-sm",
                  id: "apresentacao"
                }, [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(apresentacoes, (item) => {
                    return _createElementVNode("option", {
                      key: item,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_5)
                  }), 64))
                ], 512), [
                  [_vModelSelect, controle.apresentacao]
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "Status", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((controle.filtros.ativo) = $event)),
                  class: "form-select form-select-sm",
                  id: "ativo"
                }, [...(_cache[12] || (_cache[12] = [
                  _createElementVNode("option", { value: null }, "Todos", -1),
                  _createElementVNode("option", { value: true }, "Ativos", -1),
                  _createElementVNode("option", { value: false }, "Inativos", -1)
                ]))], 512), [
                  [_vModelSelect, controle.filtros.ativo]
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _cache[14] || (_cache[14] = _createElementVNode("label", null, "Cidade", -1)),
                _createVNode(DropdownCidadesAtiva, {
                  modelValue: controle.filtros.cidadeId,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((controle.filtros.cidadeId) = $event)),
                  id: "cidadeId",
                  onSelected: selecionouCidade
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[15] || (_cache[15] = _createElementVNode("label", null, "Empresa", -1)),
                _createVNode(DropdownEmpresas, {
                  modelValue: controle.filtros.empresaId,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((controle.filtros.empresaId) = $event)),
                  id: "empresaId",
                  onSelected: selecionouEmpresa
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[17] || (_cache[17] = _createElementVNode("label", null, "Com Dependentes", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((controle.filtros.comDependentes) = $event)),
                  class: "form-select form-select-sm",
                  id: "comDependentes"
                }, [...(_cache[16] || (_cache[16] = [
                  _createElementVNode("option", { value: true }, "Sim", -1),
                  _createElementVNode("option", { value: false }, "Não", -1)
                ]))], 512), [
                  [_vModelSelect, controle.filtros.comDependentes]
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(controle.usarIdadeInicial ? 'Idade Inicial' : 'Dt Nasc Inicial') + " ", 1),
                  _createElementVNode("a", {
                    href: "#",
                    class: "small",
                    onClick: _withModifiers(alternarIdadeInicial, ["prevent"]),
                    title: controle.usarIdadeInicial ? 'Usar data' : 'Usar idade'
                  }, [...(_cache[18] || (_cache[18] = [
                    _createElementVNode("i", { class: "fa fa-repeat" }, null, -1)
                  ]))], 8, _hoisted_11)
                ]),
                (!controle.usarIdadeInicial)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((controle.filtros.dataNascimentoInicial) = $event)),
                      type: "date",
                      class: "form-control form-control-sm",
                      id: "dataNascimentoInicial"
                    }, null, 512)), [
                      [_vModelText, controle.filtros.dataNascimentoInicial]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((controle.idadeInicial) = $event)),
                      onInput: atualizarDataPelaIdadeInicial,
                      type: "number",
                      min: "0",
                      class: "form-control form-control-sm",
                      id: "idadeInicial"
                    }, null, 544)), [
                      [
                        _vModelText,
                        controle.idadeInicial,
                        void 0,
                        { number: true }
                      ]
                    ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(controle.usarIdadeFinal ? 'Idade Final' : 'Dt Nasc Final') + " ", 1),
                  _createElementVNode("a", {
                    href: "#",
                    class: "small",
                    onClick: _withModifiers(alternarIdadeFinal, ["prevent"]),
                    title: controle.usarIdadeFinal ? 'Usar data' : 'Usar idade'
                  }, [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("i", { class: "fa fa-repeat" }, null, -1)
                  ]))], 8, _hoisted_13)
                ]),
                (!controle.usarIdadeFinal)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((controle.filtros.dataNascimentoFinal) = $event)),
                      type: "date",
                      class: "form-control form-control-sm",
                      id: "dataNascimentoFinal"
                    }, null, 512)), [
                      [_vModelText, controle.filtros.dataNascimentoFinal]
                    ])
                  : _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((controle.idadeFinal) = $event)),
                      onInput: atualizarDataPelaIdadeFinal,
                      type: "number",
                      min: "0",
                      class: "form-control form-control-sm",
                      id: "idadeFinal"
                    }, null, 544)), [
                      [
                        _vModelText,
                        controle.idadeFinal,
                        void 0,
                        { number: true }
                      ]
                    ])
              ]),
              _createElementVNode("div", { class: "col-md-2 col-6" }, [
                _createElementVNode("a", {
                  class: "btn btn-primary btn-sm mt-4",
                  onClick: pesquisar
                }, [...(_cache[20] || (_cache[20] = [
                  _createElementVNode("i", { class: "fa fa-search me-1" }, null, -1),
                  _createTextVNode(" Pesquisar ", -1)
                ]))])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[21] || (_cache[21] = _createElementVNode("a", {
                    class: "btn btn-outline-secondary btn-sm dropdown-toggle mt-4",
                    href: "#",
                    role: "button",
                    "data-bs-toggle": "dropdown",
                    "aria-expanded": "false"
                  }, [
                    _createElementVNode("i", { class: "fa fa-table-columns me-1" }),
                    _createTextVNode(" Colunas ")
                  ], -1)),
                  _createElementVNode("ul", _hoisted_16, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(colunasOpcionais, (col) => {
                      return _createElementVNode("li", {
                        key: col.chave
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: 'col_' + col.chave,
                            "onUpdate:modelValue": ($event: any) => ((controle.colunasVisiveis[col.chave]) = $event)
                          }, null, 8, _hoisted_18), [
                            [_vModelCheckbox, controle.colunasVisiveis[col.chave]]
                          ]),
                          _createElementVNode("label", {
                            class: "form-check-label",
                            for: 'col_' + col.chave
                          }, _toDisplayString(col.label), 9, _hoisted_19)
                        ])
                      ])
                    }), 64))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("a", {
                  class: "btn btn-outline-secondary btn-sm mt-4",
                  href: "#",
                  title: "Gerar Excel (.xlsx)",
                  onClick: _withModifiers(gerarExcel, ["prevent"])
                }, [...(_cache[22] || (_cache[22] = [
                  _createElementVNode("i", { class: "fa fa-file-excel me-1" }, null, -1),
                  _createTextVNode(" Gerar Excel ", -1)
                ]))])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createVNode(ReportView, {
            titulo: 'Rel Clientes',
            btnImprimir: true
          }, {
            default: _withCtx(() => [
              (controle.erro != '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(controle.erro), 1)
                  ]))
                : _createCommentVNode("", true),
              (controle.erro == '' && controle.pesquisando)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [...(_cache[23] || (_cache[23] = [
                    _createElementVNode("div", { class: "p-4" }, [
                      _createElementVNode("i", { class: "fa fa-cog fa-2x fa-spin" }),
                      _createElementVNode("div", { class: "fw-16" }, "Pesquisando...")
                    ], -1)
                  ]))]))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    (controle.apresentacao === 'Normal')
                      ? (_openBlock(), _createBlock(RelNormal, {
                          key: 0,
                          clientes: controle.itens,
                          filtros: resumoFiltros.value
                        }, null, 8, ["clientes", "filtros"]))
                      : _createCommentVNode("", true),
                    (controle.apresentacao === 'Assistência Funeral')
                      ? (_openBlock(), _createBlock(RelFuneral, {
                          key: 1,
                          clientes: controle.itens,
                          filtros: resumoFiltros.value
                        }, null, 8, ["clientes", "filtros"]))
                      : _createCommentVNode("", true),
                    (controle.apresentacao === 'Seguro')
                      ? (_openBlock(), _createBlock(RelSeguro, {
                          key: 2,
                          clientes: controle.itens,
                          filtros: resumoFiltros.value
                        }, null, 8, ["clientes", "filtros"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length === 0 && controle.totalRegistros === 0 && controle.status === '')
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [...(_cache[24] || (_cache[24] = [
                    _createTextVNode(" Utilize os filtros acima e clique em ", -1),
                    _createElementVNode("strong", null, "Pesquisar", -1),
                    _createTextVNode(" para gerar o relatório. ", -1)
                  ]))]))
                : _createCommentVNode("", true),
              (controle.erro == '' && !controle.pesquisando && controle.itens.length === 0 && controle.totalRegistros > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Nenhum cliente encontrado com os filtros selecionados."))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})